import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { goBackOneQuestion } from "~/patients/api";

export const useGoBackOneQuestion = () => {
  const queryClient = useQueryClient();

  const { mutate: goBackOneQuestionMutation, isPending } = useMutation({
    mutationFn: goBackOneQuestion,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["getCurrentScreeningQuestion"],
      });
    },
    onError: () =>
      toast.error(
        "Unable to go back to the previous question. If the issue persists, please refresh the page.",
      ),
  });

  return { goBackOneQuestionMutation, isPending };
};
